import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { f as d } from "./index-LyFokDcn.mjs";
import { m as x } from "./tss-DN0acMKN.mjs";
import { M as u, d as h } from "./constants-CnFYFetN.mjs";
import { c as p } from "./index-DkZ16bcJ.mjs";
import { m as f } from "./mui-DV6TgX2g.mjs";
import { C as g } from "./card-vPwejA0-.mjs";
import { F as y } from "./flex-Cc3osQLf.mjs";
import { I as w } from "./icon-v2-DGtVEk7e.mjs";
import { L as v } from "./layout-box-DFBM-kSI.mjs";
import { B as S } from "./base-headline-Dw8BrcrM.mjs";
const j = x()((e, t, s) => {
  const { palette: o, mixins: r, transitions: n, mode: l } = e, { hasHover: a } = t, c = {
    easing: n.easing.easeInOut,
    duration: n.duration.short
  };
  return {
    root: {
      border: a ? void 0 : r.border(1, o.gray[300]),
      borderRadius: a ? void 0 : "8px",
      boxShadow: a ? void 0 : "0px 2px 16px rgba(0, 0, 0, 0.15)",
      boxSizing: "border-box",
      display: "flex",
      flexFlow: "column nowrap",
      height: "100%",
      outline: l === u.Dye ? `1px solid ${h.main}` : void 0,
      transition: n.create("box-shadow", c),
      "&:hover": a ? {
        border: r.border(1, o.gray[300]),
        borderRadius: "8px",
        boxShadow: "0px 2px 16px rgba(0, 0, 0, 0.15)",
        [`& .${s.header}`]: {
          backgroundColor: o.gray[100],
          border: "none",
          borderBottom: r.border(1, o.gray[300]),
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px"
        },
        [`& .${s.children}`]: {
          border: "none",
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          boxShadow: "none"
        },
        "& .showOnHover": {
          display: "block"
        }
      } : {},
      "& .showOnHover": {
        display: a ? "none" : "block"
      }
    },
    header: {
      backgroundColor: a ? "transparent" : o.gray[100],
      border: a ? r.border(1, "transparent") : "none",
      borderBottom: a ? "none" : r.border(1, o.gray[300]),
      borderTopLeftRadius: a ? void 0 : "8px",
      borderTopRightRadius: a ? void 0 : "8px",
      boxSizing: "border-box",
      transition: n.create("background-color", c)
    },
    children: {
      background: o.common.white,
      border: a ? r.border(1, o.gray[300]) : "none",
      borderRadius: "8px",
      borderTopLeftRadius: a ? "8px" : 0,
      borderTopRightRadius: a ? "8px" : 0,
      boxShadow: a ? "0px 2px 6px rgba(0, 0, 0, 0.05)" : "none",
      boxSizing: "border-box",
      display: "flex",
      flexFlow: "column nowrap",
      flexGrow: 1,
      transition: n.create("box-shadow", c)
    }
  };
}), F = x()((e, t, s) => {
  const { palette: o, mixins: r } = e, { hasHover: n } = t;
  return {
    root: {
      boxSizing: "border-box",
      display: "flex",
      flexFlow: "column nowrap",
      height: "100%",
      "& :first-child": {
        transition: d.ifFeature("encore", "background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out"),
        [`&:hover .${s.header}`]: {
          backgroundColor: o.gray[50]
        }
      },
      "&:hover": {
        "& .showOnHover": {
          display: "block"
        }
      },
      "& .showOnHover": {
        display: n ? "none" : "block"
      }
    },
    card: {
      display: "flex",
      flexDirection: "column",
      height: "100%"
    },
    header: {
      backgroundColor: o.common.white,
      borderBottom: r.border(1, o.gray[200])
    },
    children: {
      boxSizing: "border-box",
      display: "flex",
      flexFlow: "column nowrap",
      flexGrow: 1,
      overflow: "auto"
    }
  };
}), R = x()(({ spacing: e }) => ({
  root: {
    boxSizing: "border-box",
    flexGrow: 1,
    overflowY: "auto",
    padding: d.ifFeature("encore", e(2), "24px")
  }
})), k = ({ children: e, className: t, ...s }) => {
  const { classes: o } = R();
  return /* @__PURE__ */ i.jsx("div", { className: p(o.root, t), ...s, children: e });
}, H = x()((e, t) => {
  const { mixins: s, palette: o, spacing: r } = e, { hasDivider: n } = t;
  return {
    root: {
      padding: d.ifFeature("encore", `0 ${r(2)} ${r(2)}`, n ? "0 24px 24px" : "12px 24px 24px"),
      "&:before": n ? {
        borderTop: s.border(1, d.ifFeature("encore", o.gray[200], o.gray[300])),
        boxSizing: "border-box",
        content: '""',
        display: "block",
        marginBottom: d.ifFeature("encore", r(2), 12)
      } : { display: "none" }
    }
  };
}), C = ({ children: e, className: t, hasDivider: s, ...o }) => {
  const { classes: r } = H({ hasDivider: s });
  return /* @__PURE__ */ i.jsx("footer", { className: p(r.root, t), ...o, children: e });
}, O = x()(({ spacing: e }) => ({
  root: {
    padding: d.ifFeature("encore", e(2), "13px 24px 12px")
  },
  title: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }
})), N = ({ children: e, className: t, icon: s, right: o, title: r, ...n }) => {
  const { classes: l } = O();
  return /* @__PURE__ */ i.jsxs("div", { className: p(l.root, t), ...n, children: [
    d.ifFeature(
      "encore",
      /* @__PURE__ */ i.jsxs(y, { alignItems: "center", gap: 1.5, children: [
        typeof s == "string" ? /* @__PURE__ */ i.jsx(w, { color: "primary-strong", name: s, size: 20 }) : s,
        r || r === 0 ? /* @__PURE__ */ i.jsx(S, { classes: { root: l.title }, size: "extra-small", children: r }) : null,
        o || o === 0 ? /* @__PURE__ */ i.jsx(v, { marginLeft: "auto", children: o }) : null
      ] })
    ),
    e
  ] });
}, $ = f(() => ({
  root: {
    display: "none"
  }
})), z = ({ children: e, className: t, ...s }) => {
  const o = $();
  return /* @__PURE__ */ i.jsx("div", { className: p(o.root, "showOnHover", t), ...s, children: e });
}, b = ({ children: e, className: t, hasHover: s, header: o, ...r }) => {
  const { classes: n, cx: l } = j({ hasHover: s }), { classes: a } = F({ hasHover: s }), c = /* @__PURE__ */ i.jsxs("section", { className: l(n.root, t), ...r, "data-fabric-component": "Gridlet", children: [
    o && /* @__PURE__ */ i.jsx("header", { className: n.header, children: o }),
    /* @__PURE__ */ i.jsx("div", { className: n.children, children: e })
  ] }), m = /* @__PURE__ */ i.jsx("section", { className: a.root, "data-fabric-component": "Gridlet", children: /* @__PURE__ */ i.jsxs(g, { classes: { root: a.card }, encoreOnly: !0, hasHover: !0, children: [
    o && /* @__PURE__ */ i.jsx("header", { className: a.header, children: o }),
    /* @__PURE__ */ i.jsx("div", { className: a.children, children: e })
  ] }) });
  return d.ifFeature("encore", m, c);
};
b.Body = k;
b.Footer = C;
b.Header = N;
b.ShowOnHover = z;
export {
  b as G
};
//# sourceMappingURL=gridlet-DhSNi0ep.mjs.map
